<template>
  <div
    :class="{
      [$style.connector]: true,
      [$style[layout]]: true,
      [$style['left-rounded']]: isLeftRounded,
      [$style['right-rounded']]: isRightRounded,
      [$style['last-selected']]: isLastSelected,
      [$style['horizontal']]: layout === 'horizontal',
      [$style['vertical']]: layout === 'vertical',
      [$style[variation]]: true,
    }"
  >
    <div :class="{[$style.filled]: filled}" />
    <div :class="{[$style.filled]: filled && !partialFilled}" />
  </div>
</template>

<script>
export default {
  name: 'ProgressConnector',
  props: {
    isLastSelected: {
      type: Boolean,
    },
    partialFilled: {
      type: Boolean,
    },
    filled: {
      type: Boolean,
    },
    isLeftRounded: {
      type: Boolean,
    },
    isRightRounded: {
      type: Boolean,
    },
    layout: {
      type: String,
      required: true,
    },
    variation: {
      type: String,
      default: 'secondary',
    },
  },
  data() {
    return {
      $style: this.$style,
    };
  },
};
</script>

<style lang="scss" module>
.connector {
	display: flex;
	flex: 1;
	overflow: hidden;
  background: var(--p-timeline-event-connector-background-color);
}
.connector > * {
	flex: 1;
}

.connector.primary > .filled {
  background: var(--p-timeline-color-primary-color);
}
.connector.error > .filled {
  background: var(--p-timeline-color-error-color);
}
.connector.warning > .filled {
  background: var(--p-timeline-color-warning-color);
}
.connector.success > .filled {
  background: var(--p-timeline-color-success-color);
}
.connector.disabled > .filled {
  background: var(--p-timeline-color-disable-color);
}
.connector.monochrome > .filled {
  background: var(--p-timeline-color-monochrome-color);
}
.connector.secondary > .filled {
  background: var(--p-timeline-color-secondary-color);
}
.connector.horizontal {
  height: var(--p-timeline-event-progressive-connector-size);
}
.connector.vertical {
  width: var(--p-timeline-event-progressive-connector-size);
}
.connector.horizontal.last-selected > :nth-last-child(1 of .filled) {
	border-bottom-right-radius: var(--p-timeline-event-marker-border-radius);
	border-top-right-radius: var(--p-timeline-event-marker-border-radius);
}
.connector.vertical.last-selected > :nth-last-child(1 of .filled) {
	border-bottom-right-radius: var(--p-timeline-event-marker-border-radius);
	border-bottom-left-radius: var(--p-timeline-event-marker-border-radius);
}
.connector.horizontal.left-rounded {
	border-bottom-left-radius: var(--p-timeline-event-marker-border-radius);
	border-top-left-radius: var(--p-timeline-event-marker-border-radius);
}
.connector.horizontal.right-rounded {
	border-bottom-right-radius: var(--p-timeline-event-marker-border-radius);
	border-top-right-radius: var(--p-timeline-event-marker-border-radius);
}
.connector.vertical {
	flex-direction: column;
}
.connector.vertical.left-rounded {
	border-top-left-radius: var(--p-timeline-event-marker-border-radius);
	border-top-right-radius: var(--p-timeline-event-marker-border-radius);
}
.connector.vertical.right-rounded {
	border-bottom-left-radius: var(--p-timeline-event-marker-border-radius);
	border-bottom-right-radius: var(--p-timeline-event-marker-border-radius);
}
</style>
